interface IconProps{
    height:string;
    width:string;
    fill?:string;
}
const History = ({height,width,fill}:IconProps) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height={height} width={width}>
      <g>
        <g>
          <path fill={fill !== undefined ? fill:"rgb(23, 100, 179)"} d="M78.9 40.4c.1-.1.1-.3.1-.4V9c0-2.8-2.2-5-5-5H14c-2.8 0-5 2.2-5 5v60c0 2.8 2.2 5 5 5h16c.1 0 .2 0 .3-.1C34.2 86.7 46 96 60 96c17.1 0 31-13.9 31-31 0-10-4.7-18.9-12.1-24.6zM14 6h60c1.7 0 3 1.3 3 3v7H11V9c0-1.7 1.3-3 3-3zm0 66c-1.7 0-3-1.3-3-3V18h66v21c-3.3-2.1-7-3.7-11-4.5V30c0-.4-.2-.7-.5-.9-.3-.2-.7-.2-1 0l-13 8c-.3.2-.5.6-.5.9 0 .3.2.7.5.9l13 8c.3.2.7.2 1 0 .3-.2.5-.5.5-.9v-4.2C76.5 44.5 84 54 84 65c0 13.2-10.8 24-24 24S36 78.2 36 65c0-8.4 4.5-16.3 11.7-20.6.4-.3.6-.8.4-1.3l-2-4.6c-.1-.3-.3-.5-.6-.5-.3-.1-.6-.1-.8.1C35 43.5 29 53.9 29 65c0 2.4.3 4.7.8 7H14zm46 22c-16 0-29-13-29-29 0-10 5.2-19.4 13.7-24.6l1.2 2.8C38.6 47.9 34 56.2 34 65c0 14.3 11.7 26 26 26s26-11.7 26-26c0-12.3-8.7-23-20.8-25.5-.3-.1-.6 0-.8.2-.2.2-.4.5-.4.8v3.7L53.9 38 64 31.8v3.6c0 .5.4.9.8 1C78.8 38.8 89 50.8 89 65c0 16-13 29-29 29z"></path>
          <path  d="M60 69c1.9 0 3.4-1.3 3.9-3H79c.6 0 1-.4 1-1s-.4-1-1-1H63.9c-.4-1.4-1.5-2.5-2.9-2.9V52c0-.6-.4-1-1-1s-1 .4-1 1v9.1c-1.7.4-3 2-3 3.9 0 2.2 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"></path>
          <circle cx="71" cy="11" r="2"></circle>
          <circle cx="65" cy="11" r="2"></circle>
          <circle cx="59" cy="11" r="2"></circle>
          <path fill={fill !== undefined ? fill:"rgb(23, 100, 179)"} d="M23 21h-7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1zM23 25h-7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1zM23 29h-7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1z"></path>
        </g>
      </g>
    </svg>
    )
}
const Details = ({height,width}:IconProps) =>{
    
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    width={width}
    height={height}
  >
    <g>
      <g>
        <linearGradient
          id="SVGID_1_"
          x1="104.153"
          x2="387.508"
          y1="343.669"
          y2="180.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ed1d32"></stop>
          <stop offset="0.131" stopColor="#9e0e0e"></stop>
          <stop offset="0.335" stopColor="#b33511"></stop>
          <stop offset="0.349" stopColor="#bb3c11"></stop>
          <stop offset="0.714" stopColor="#e8710f"></stop>
          <stop offset="1" stopColor="#fbc202"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_1_)"
          d="M169 422h174c18.748 0 34-15.252 34-34V171.012c0-9.082-3.537-17.62-9.958-24.042l-47.013-47.012C313.608 93.537 305.07 90 295.988 90H169c-18.748 0-34 15.252-34 34v264c0 18.748 15.252 34 34 34zm190.971-267.958c.469.469.911.958 1.336 1.458H327.5c-9.374 0-17-7.626-17-17v-33.613a24.452 24.452 0 012.459 2.143l47.012 47.012zM145 124c0-13.233 10.767-24 24-24h126.988c1.531 0 3.039.146 4.512.425V138.5c0 14.888 12.112 27 27 27h38.861c.418 1.787.639 3.632.639 5.512V388c0 13.233-10.767 24-24 24H169c-13.233 0-24-10.767-24-24V124z"
        ></path>
        <linearGradient
          id="SVGID_2_"
          x1="171.449"
          x2="211.716"
          y1="168.29"
          y2="145.041"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ed1d32"></stop>
          <stop offset="0.131" stopColor="#9e0e0e"></stop>
          <stop offset="0.335" stopColor="#b33511"></stop>
          <stop offset="0.349" stopColor="#bb3c11"></stop>
          <stop offset="0.714" stopColor="#e8710f"></stop>
          <stop offset="1" stopColor="#fbc202"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_2_)"
          d="M167.625 151.667H215.542V161.667H167.625z"
        ></path>
        <linearGradient
          id="SVGID_3_"
          x1="300.262"
          x2="340.529"
          y1="380.29"
          y2="357.042"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ed1d32"></stop>
          <stop offset="0.131" stopColor="#9e0e0e"></stop>
          <stop offset="0.335" stopColor="#b33511"></stop>
          <stop offset="0.349" stopColor="#bb3c11"></stop>
          <stop offset="0.714" stopColor="#e8710f"></stop>
          <stop offset="1" stopColor="#fbc202"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_3_)"
          d="M296.438 363.666H344.354V373.666H296.438z"
        ></path>
        <linearGradient
          id="SVGID_4_"
          x1="187.551"
          x2="324.427"
          y1="267.013"
          y2="187.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ed1d32"></stop>
          <stop offset="0.131" stopColor="#9e0e0e"></stop>
          <stop offset="0.335" stopColor="#b33511"></stop>
          <stop offset="0.349" stopColor="#bb3c11"></stop>
          <stop offset="0.714" stopColor="#e8710f"></stop>
          <stop offset="1" stopColor="#fbc202"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_4_)"
          d="M167.625 222.5H344.35400000000004V232.5H167.625z"
        ></path>
        <linearGradient
          id="SVGID_5_"
          x1="187.551"
          x2="324.427"
          y1="337.596"
          y2="258.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ed1d32"></stop>
          <stop offset="0.131" stopColor="#9e0e0e"></stop>
          <stop offset="0.335" stopColor="#b33511"></stop>
          <stop offset="0.349" stopColor="#bb3c11"></stop>
          <stop offset="0.714" stopColor="#e8710f"></stop>
          <stop offset="1" stopColor="#fbc202"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_5_)"
          d="M167.625 293.084H344.35400000000004V303.084H167.625z"
        ></path>
      </g>
    </g>
  </svg>
  )
}
const AddedRow = ({height,width,fill}:IconProps) => {
    return(
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width={height}
      height={width}
      fill={fill}
      version="1.1"
      viewBox="0 0 502 502"
      xmlSpace="preserve"
      
    >
      <g>
        <path d="M405.889 348.576V105.273c0-2.652-1.054-5.196-2.929-7.071L307.688 2.929A10.003 10.003 0 00300.617 0H70.783c-5.523 0-10 4.477-10 10v445.916c0 5.523 4.477 10 10 10h216.442C303.083 488.611 328.615 502 356.57 502c46.674 0 84.646-37.972 84.646-84.646.001-27.527-13.114-52.869-35.327-68.778zM80.783 20h215.691l76.158 76.158h-51.151c-5.522 0-10 4.477-10 10s4.478 10 10 10h64.408v221.789a84.497 84.497 0 00-29.319-5.241c-46.675 0-84.647 37.973-84.647 84.647 0 9.793 1.692 19.45 4.955 28.562H80.783V20zM356.57 482c-22.766 0-43.43-11.629-55.277-31.107-6.13-10.077-9.37-21.675-9.37-33.539 0-35.646 29.001-64.647 64.647-64.647a64.43 64.43 0 0133.334 9.278c.474.355.979.67 1.513.938 18.668 11.975 29.799 32.278 29.799 54.431C421.217 453 392.217 482 356.57 482z"></path>
        <path d="M394.345 407.354h-27.776v-27.776c0-5.523-4.478-10-10-10s-10 4.477-10 10v27.776h-27.776c-5.522 0-10 4.477-10 10s4.478 10 10 10h27.776v27.776c0 5.523 4.478 10 10 10s10-4.477 10-10v-27.776h27.776c5.522 0 10-4.477 10-10s-4.477-10-10-10zM292.56 106.158c0-5.523-4.478-10-10-10h-11.447c-5.522 0-10 4.477-10 10s4.478 10 10 10h11.447c5.523 0 10-4.477 10-10z"></path>
      </g>
    </svg>
    )
}
const ChangedRow = ({height,width,fill}:IconProps) => {
    return(
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
        version="1.1"
        viewBox="0 0 452.025 452.025"
        xmlSpace="preserve"
      >
        <g>
          <path d="M362.612 34.125h-55.2l13.6-13.6c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-34 34.1c-2.3 2.3-3.5 5.3-3.5 8.5s1.3 6.2 3.5 8.5l34.1 34.1c2.3 2.3 5.4 3.5 8.5 3.5s6.1-1.2 8.5-3.5c4.7-4.7 4.7-12.3 0-17l-13.6-13.6h55.2c35.9 0 65 29.2 65 65v40.3c0 6.6 5.4 12 12 12s12-5.4 12-12v-40.3c0-49.1-40-89-89.1-89zM438.812 230.925h-197.1c-6.6 0-12 5.4-12 12v197.1c0 6.6 5.4 12 12 12h197.1c6.6 0 12-5.4 12-12v-197.1c0-6.7-5.4-12-12-12zm-12 197.1h-173.1v-173.1h173.1v173.1zM147.912 363.325c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l13.6 13.6h-55.2c-35.9 0-65-29.2-65-65v-40.3c0-6.6-5.4-12-12-12s-12 5.4-12 12v40.3c0 49.1 39.9 89 89 89h55.2l-13.6 13.6c-4.7 4.7-4.7 12.3 0 17 2.3 2.3 5.4 3.5 8.5 3.5s6.1-1.2 8.5-3.5l34.1-34.1c4.7-4.7 4.7-12.3 0-17l-34.1-34.1zM13.212 24.025c3.2 0 6.3-1.3 8.5-3.5s3.5-5.3 3.5-8.5c0-3.1-1.3-6.3-3.5-8.5s-5.3-3.5-8.5-3.5-6.3 1.3-8.5 3.5-3.5 5.3-3.5 8.5 1.3 6.3 3.5 8.5c2.3 2.2 5.3 3.5 8.5 3.5zM111.812 24.025c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.3 12 12 12zM62.512 24.025c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.4 12 12 12zM161.012 24.025c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.4 12 12 12zM210.312.025c-3.1 0-6.3 1.3-8.5 3.5s-3.5 5.3-3.5 8.5 1.3 6.3 3.5 8.5 5.3 3.5 8.5 3.5 6.3-1.3 8.5-3.5 3.5-5.3 3.5-8.5-1.3-6.3-3.5-8.5-5.3-3.5-8.5-3.5zM210.312 147.925c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12c0-6.7-5.3-12-12-12zM210.312 98.625c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12c0-6.7-5.3-12-12-12zM210.312 49.325c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.3-12-12-12zM210.312 197.125c-3.2 0-6.3 1.3-8.5 3.5s-3.5 5.3-3.5 8.5c0 3.1 1.3 6.3 3.5 8.5s5.3 3.5 8.5 3.5 6.3-1.3 8.5-3.5 3.5-5.3 3.5-8.5-1.3-6.3-3.5-8.5c-2.199-2.2-5.3-3.5-8.5-3.5zM161.012 221.125c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12c0 6.7 5.4 12 12 12zM111.812 221.125c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12c0 6.7 5.3 12 12 12zM62.512 221.125c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12c0 6.7 5.4 12 12 12zM13.212 221.125c3.2 0 6.3-1.3 8.5-3.5s3.5-5.3 3.5-8.5-1.3-6.3-3.5-8.5-5.3-3.5-8.5-3.5-6.3 1.3-8.5 3.5-3.5 5.3-3.5 8.5c0 3.1 1.3 6.3 3.5 8.5 2.3 2.2 5.3 3.5 8.5 3.5zM13.212 171.925c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.4 12 12 12zM13.212 122.625c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.4 12 12 12zM13.212 73.325c6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12 5.4 12 12 12z"></path>
        </g>
      </svg>
    )
}
const DeletedRow = ({height,width,fill}:IconProps) => {
    return(
        <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        version="1.1"
        viewBox="0 0 64 64"
        xmlSpace="preserve"
        width={width}
        height={height}
      >
        <g fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth="3">
          <path d="M25 8L25 1 39 1 39 8"></path>
          <path d="M14 10L14 63 50 63 50 10"></path>
          <path d="M26 20L26 54"></path>
          <path d="M38 20L38 54"></path>
          <path d="M10 9L54 9"></path>
        </g>
      </svg>
    )
}
const StatisticsReport = ({height,width,fill}:IconProps) => {
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="#fff"
      stroke="#fff"
      strokeWidth="0.005"
      version="1.1"
      viewBox="-163.84 -163.84 839.68 839.68"
      xmlSpace="preserve"
    >
      <path
        fill={fill}
        opacity={"0.8"}
        strokeWidth="0"
        d="M317.192-146.522a118.08 118.08 0 00-122.384 0L-80.712 20.47A118.08 118.08 0 00-137.6 121.44V390.56A118.08 118.08 0 00-80.712 491.53l275.52 166.992a118.08 118.08 0 00122.384 0l275.52-166.992A118.08 118.08 0 00649.6 390.56V121.44A118.08 118.08 0 00592.712 20.47l-275.52-166.992z"
      ></path>
      <g>
        <path d="M128.257 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM179.457 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM247.468 273.067h-68.267c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533h68.267c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533zM213.334 324.267h-34.133a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533h34.133a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533zM358.401 298.667c-9.412 0-17.067-7.654-17.067-17.067 0-4.71-3.814-8.533-8.533-8.533s-8.533 3.823-8.533 8.533c0 15.855 10.914 29.107 25.6 32.922v1.212a8.53 8.53 0 008.533 8.533 8.53 8.53 0 008.533-8.533v-1.212c14.686-3.814 25.6-17.067 25.6-32.922 0-18.825-15.309-34.133-34.133-34.133-9.412 0-17.067-7.654-17.067-17.067 0-9.412 7.654-17.067 17.067-17.067 9.412 0 17.067 7.654 17.067 17.067 0 4.71 3.814 8.533 8.533 8.533s8.533-3.823 8.533-8.533c0-15.855-10.914-29.107-25.6-32.922v-1.212a8.53 8.53 0 00-8.533-8.533 8.53 8.53 0 00-8.533 8.533v1.212c-14.686 3.814-25.6 17.067-25.6 32.922 0 18.825 15.309 34.133 34.133 34.133 9.412 0 17.067 7.654 17.067 17.067 0 9.412-7.655 17.067-17.067 17.067zM333.057 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533c4.71 0 8.533-3.823 8.533-8.533s-3.822-8.533-8.533-8.533zM435.457 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM384.257 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533c4.71 0 8.533-3.823 8.533-8.533s-3.822-8.533-8.533-8.533zM349.868 102.4h34.133a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533h-34.133a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533zM230.657 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM128.001 290.133h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM128.001 341.333h17.067a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533h-17.067a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533z"></path>
        <path d="M469.334 0H42.668a8.53 8.53 0 00-8.533 8.533v494.933a8.536 8.536 0 005.265 7.885 8.535 8.535 0 009.301-1.852l45.167-45.167 45.167 45.167a8.523 8.523 0 0012.066 0l28.1-28.1 28.1 28.1a8.523 8.523 0 0012.066 0l28.1-28.1 11.034 11.034a8.525 8.525 0 0012.066 0l28.1-28.1 28.1 28.1a8.525 8.525 0 0012.066 0l19.567-19.567 19.567 19.567a8.525 8.525 0 0012.066 0l45.167-45.167 28.1 28.1c.171.179.35.341.538.495 0 .009.008.009.008.009v.009a8.54 8.54 0 005.112 1.98c.316.009.631.009.964-.009h.009a8.515 8.515 0 005.853-2.935 8.523 8.523 0 002.082-5.564V8.533A8.528 8.528 0 00469.334 0zm-8.533 448.734l-19.567-19.567a8.525 8.525 0 00-12.066 0l-45.167 45.167-19.567-19.567a8.523 8.523 0 00-12.066 0l-19.567 19.567-28.1-28.1a8.523 8.523 0 00-12.066 0l-28.1 28.1-11.034-11.034a8.523 8.523 0 00-12.066 0l-28.1 28.1-28.1-28.1a8.51 8.51 0 00-6.033-2.5 8.509 8.509 0 00-6.033 2.5l-28.1 28.1-45.167-45.167a8.523 8.523 0 00-12.066 0l-36.634 36.634v-465.8h409.6v431.667z"></path>
        <path d="M77.057 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM128.001 238.933h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM281.857 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM179.201 187.733h51.2c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-51.2c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM128.001 187.733h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM264.534 221.867h-85.333c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533h85.333c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533zM128.001 102.4h136.533a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533H128.001a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533z"></path>
      </g>
    </svg>
  );
}
const KickbackReport = ({height,width,fill}:IconProps) =>{
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="#fff"
      version="1.1"
      viewBox="-51.2 -51.2 614.4 614.4"
      xmlSpace="preserve"
    >
      <g>
        <path
          fill={fill}
          d="M256 .032L0 246.768h91.472v265.2H432.24v-265.2H512L256 .032z"
        ></path>
        <g fill="#FFF">
          <path d="M246.64 407.328v-48.72c-15.2-4.336-26.336-10.912-33.424-19.696s-10.64-19.488-10.64-32.048c0-12.704 4.016-23.392 12.032-32.032s18.688-13.632 32.032-14.944v-11.52h16.864v11.52c12.336 1.472 22.128 5.664 29.424 12.608 7.28 6.944 11.936 16.24 13.952 27.856l-29.424 3.824c-1.776-9.136-6.432-15.344-13.952-18.592v45.456c18.608 5.04 31.28 11.584 38.032 19.6 6.736 8.032 10.112 18.32 10.112 30.88 0 14.032-4.256 25.856-12.736 35.472s-20.288 15.504-35.408 17.664V456.4H246.64v-21.168c-13.408-1.632-24.304-6.624-32.672-15.008-8.368-8.368-13.712-20.192-16.048-35.472l30.336-3.248c1.248 6.208 3.568 11.552 6.976 16.048 3.424 4.512 7.216 7.76 11.408 9.776zm0-122.096c-4.576 1.568-8.224 4.192-10.928 7.904s-4.064 7.824-4.064 12.336c0 4.112 1.248 7.92 3.712 11.456 2.48 3.536 6.24 6.368 11.28 8.544v-40.24zm16.848 123.712c5.808-1.072 10.528-3.776 14.192-8.08 3.648-4.304 5.472-9.36 5.472-15.168 0-5.184-1.536-9.664-4.592-13.44-3.056-3.744-8.08-6.64-15.056-8.656v45.344h-.016zM145.28 175.152L256 68.432l110.72 106.72H145.28z"></path>
        </g>
      </g>
    </svg>
  );
}
const CrossIcon = ({height,width,fill}:IconProps) => {
  return(
    <svg 
    width={width}
    height={height} 
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill={fill}
      id="SVGRepo_iconCarrier"
      d="m18.8 16 5.5-5.5c.8-.8.8-2 0-2.8-.3-.4-.8-.7-1.3-.7s-1 .2-1.4.6L16 13.2l-5.5-5.5c-.8-.8-2.1-.8-2.8 0-.4.3-.7.8-.7 1.4s.2 1 .6 1.4l5.5 5.5-5.5 5.5c-.3.4-.6.9-.6 1.5 0 .5.2 1 .6 1.4s.9.6 1.4.6 1-.2 1.4-.6l5.5-5.5 5.5 5.5c.8.8 2.1.8 2.8 0 .8-.8.8-2.1 0-2.8z"
    ></path>
  </svg>
  )
}
const ResetIcon = ({height,width,fill}:IconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1.14 0 48 48" width={width} height={height}>
    <g id="SVGRepo_iconCarrier">
      <g
        id="Group_37"
        data-name="Group 37"
        transform="translate(-627.096 -464)"
      >
        <circle
          id="Ellipse_6"
          cx="5"
          cy="5"
          r="5"
          fill={fill}
          data-name="Ellipse 6"
          transform="translate(643.191 480)"
        ></circle>
        <g id="Group_36" fill={fill}data-name="Group 36">
          <path
            id="Path_45"
            d="M629.1 485a19.037 19.037 0 0 1 38.045-1h-3.568l4.618 9.236L672.81 484h-3.669a21.035 21.035 0 0 0-42.045 1A21.323 21.323 0 0 0 648 506v-2a19.25 19.25 0 0 1-18.9-19"
            data-name="Path 45"
          ></path>
          <path
            id="Path_46"
            d="M661.191 485h-2A11.048 11.048 0 1 1 647 474.051v2.567l7.236-3.618-7.236-3.618v2.67A13 13 0 1 0 661.191 485"
            data-name="Path 46"
          ></path>
          <path
            id="Path_47"
            d="M663.191 500a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6m0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4"
            data-name="Path 47"
          ></path>
          <circle
            id="Ellipse_7"
            cx="2"
            cy="2"
            r="2"
            fill={fill}
            data-name="Ellipse 7"
            transform="translate(661.191 504)"
          ></circle>
        </g>
      </g>
    </g>
  </svg>
  )
}
export const EditIcons={
    History,
    Details,
    AddedRow,
    ChangedRow,
    DeletedRow,
    StatisticsReport,
    KickbackReport,
    CrossIcon,
    ResetIcon
}